<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title">For Larry</p>
<p class="center-text"><em class="italic">Love of my life and finest man I know. Thank you for caring about my dreams and making our marriage a bold and romantic adventure.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?538a1a7b